export default __webpack_public_path__ + "static/media/history.eb8cedad.svg";